export default __webpack_public_path__ + "static/media/Documenttation_page1.a9d9a909.svg";